import { InvertColorsIcon } from './InvertColorsIcon';

/**
 * author: Google
 * id 2B0100AC-D0EB-4B85-A9AB-EB921C9A65AC
 * name invert-colors
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/invert-colors.svg
 * tags
 * - Color 
 */
export const InvertColoursIcon = InvertColorsIcon;
export default InvertColoursIcon